import { Link } from "react-router-dom";

const Contact = () => <div className="relative">
  <div className="bg-contact min-h-[350px]" />
  <section className="full flex justify-center items-center top-0 absolute w-full h-full">
    <div className="flex flex-col justify-center items-center gap-20 h-full">
      <h2 className="text-white text-center font-poppins text-4xl">Hai bisogno di contattarci?</h2>
      <div className="text-center"><Link to={'/contatti'} className="btn-contact">Contattaci</Link></div>
    </div>
  </section>
</div>

export default Contact;